import { Component, OnInit, ViewChild } from '@angular/core';
import { LiteratureService } from '../../../core/services/literature.service';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { ActivatedRoute } from '@angular/router';
import { ILiteratureDocumentDetails } from '../../../core/models';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';

@Component({
  selector: 'app-inner',
  templateUrl: './inner.component.html',
  styleUrls: ['./inner.component.scss']
})
export class InnerComponent implements OnInit {

  //#region member/variable declaration
  @ViewChild('panelbar', { static: false }) panel;
  public expandMode: number = PanelBarExpandMode.Multiple;
  public kendoPanelBarExpandMode: any = PanelBarExpandMode;
  groupingId: string;
  lieratureDetails: ILiteratureDocumentDetails;
  literatureDetails: any[];
  literatureFilterDetails: any[];
  //gridData: ILiteratureDocumentDetails;
  //originalData: ILiteratureDocumentDetails;
  //#endregion
  constructor(private literatureService: LiteratureService, private route: ActivatedRoute,) { }
  ngOnInit() {
    this.route.params.subscribe(params => {
      this.groupingId = params.id;
    });
    if (this.groupingId) {
      this.loadGridData(this.groupingId);
    }
  }
  //#region load document details
  loadGridData(groupingId) {
    const body = {
      id: groupingId
    }
    this.literatureService.getLieratureDetails(body).subscribe((response) => {
      console.log(response);
      this.lieratureDetails = response as ILiteratureDocumentDetails;
      //this.gridData = response as ILiteratureDocumentDetails;
      this.literatureDetails = response.literatureDocumentCategory;
      this.literatureFilterDetails = this.literatureDetails;
    });
  }
  //#endregion 
  //#region label and variable declaration
  public pagelabels = {
    noteLblfirst: "Note: To view .PDF files, you must have AdobeÂ® Readerâ„¢ Version 7.0 or higher.",
    noteLblsecond: "To view the files, click on the file name listed below."
  }
  //#endregion
  //#region search functionality
  onSearchChangeFilter(query) {
    //var tempGridData = this.gridData;
    //perform search operations here
    if (query === '') {
      this.literatureFilterDetails = this.literatureDetails;
    } else {
      this.literatureFilterDetails = [];
      const result = this.filterFunc(query, this.literatureDetails);
      this.literatureFilterDetails = result;
      //this.lieratureDetails.literatureDocumentCategory = this.gridData.literatureDocumentCategory.filter((s) => s.docCategoryDesc.toLowerCase().indexOf(searchText.toLowerCase()) !== -1);
      //tempGridData.literatureDocumentCategory.forEach(result => {
      //  const tempResult = result;        
      //  const docCategoryFilteredList = tempResult.docCategoryDesc.toLowerCase().indexOf(searchText.toLowerCase()) !== -1; //returns true
      //  this.lieratureDetails.literatureDocumentCategory = docCategoryFilteredList;       
      //});
    }

  }
  filterFunc(searchText, tempGridData) {
    //const res = tempGridData.filter((s) => s.docCategoryDesc.toLowerCase().indexOf(searchText.toLowerCase()) !== -1);
    const res = tempGridData;

    tempGridData.forEach(child => {
      const sub = child;
      const filtesub = child;
      //this.literatureFilterDetails.push(sub);
      sub.literatureDocumentSubCategory.forEach(document => {
        const doc = document.literatureDocuments.filter((s) => s.docDesc.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
          || s.partNo.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
          || s.revision.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
        );
        // sub.literatureDocumentSubCategory.literatureDocuments = doc;

      });
      child.literatureDocumentSubCategory = sub;

      //const parentHasWord = child.docCategoryDesc.toLowerCase().includes(searchText) 
      // tempGridData.literatureDocumentSubCategory = child;
      tempGridData = child;
    });
    // res.literatureDocumentSubCategory
    return tempGridData;
  }
  //#endregion

}
